// extracted by mini-css-extract-plugin
module.exports = {"search-wrapper":"Search_search-wrapper__19rjZ"};